import { Controller } from "@hotwired/stimulus"
import { fetch } from 'whatwg-fetch'

export default class extends Controller {

  static values = {
    search: String
  }

  connect() {
  }

  initialize() {
  }

  changeUser(event) {
    const params = {user_id: event.target.value, loader: true}
    const urlParams = new URLSearchParams(Object.entries(params));
    const url = `/tasks?${urlParams}`

    let options = {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/vnd.turbo-stream.html",
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    }
    
    fetch(url, options)
    .then(r => r.text())
    .then(html => Turbo.renderStreamMessage(html))
  }
}
